module.exports = __webpack_public_path__ + "static/media/avatar-01@2x.7fab8d47.png";